import React from 'react';
import PageLayout from '../../layouts/page-layout/PageLayout';
import Alert from '../../ui/alert/Alert';
import Hero from '../../ui/hero/Hero';
import useAuthenticationStateErrorContent from '../../hooks/useAuthenticationStateErrorContent';

type Props = {};

const AuthenticationStateErrorView: React.FC<Props> = () => {
    const { headline, description, children, button } = useAuthenticationStateErrorContent();

    return (
        <PageLayout>
            <Hero
                mainContent={<>
                    <h1>{headline}</h1>
                    <Alert type='error' headline={description} children={children} />
                </>}
                sideContent={button}
            />
        </PageLayout>
    );
};

export default AuthenticationStateErrorView;